import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-col items-center h-full px-4 mt-10" }
const _hoisted_2 = { class: "flex flex-col items-center justify-start flex-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-col justify-center items-center bg-jm_dark_green rounded-t-3xl p-4 w-full fixed left-0 right-0 bottom-0 max-w-none min-h-[20vh] tall:min-h-[32vh]" }
const _hoisted_5 = ["src"]

import { ref, onMounted } from "vue";
import PlayButton from "@/components/PlayButton.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import logo from "@/assets/images/misc/logo_jm.svg";
import shotMachineNew from "@/assets/images/misc/logo_jm_shot_machine.svg";
import { useGlobalStore } from "@/stores/global";
import { useGameTracking } from "@/composables/useGameTracking";


export default /*@__PURE__*/_defineComponent({
  __name: 'peopleCheck',
  setup(__props) {

const animateLogo = ref(false);
const animateShotMachine = ref(false);
const globalStore = useGlobalStore();
const { kpiTracker } = useGameTracking();

onMounted(() => {
  kpiTracker.setSelectedPerson(1);
  globalStore.resetGame(1);

  setTimeout(() => {
    animateLogo.value = true;
  }, 200);

  setTimeout(() => {
    animateShotMachine.value = true;
  }, 400);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, { "background-image": "twoPeople" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo",
            class: _normalizeClass(["w-24 mx-auto mb-3 logo-jm md:w-32 lg:w-40", { 'slide-from-top': animateLogo.value }])
          }, null, 10, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(shotMachineNew),
            alt: "shot machine",
            class: _normalizeClass(["mx-auto mb-2 shot-machine animated-content h-[3.8rem] w-auto max-w-[52vw] object-contain tall:h-[5.25rem] tall:max-w-[60vw]", { 'slide-from-bottom': animateShotMachine.value }])
          }, null, 10, _hoisted_5),
          _createVNode(PlayButton, {
            class: _normalizeClass(["mb-4 animated-content", { 'slide-from-bottom': animateShotMachine.value }])
          }, null, 8, ["class"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})